export class AapColors {

    // primary/basic colors
    static White: string = "#FFFFFF";
    static Black: string = "#000000";
    static LightGrey: string = "#E6E6E6";
    static Blue: string = "#0000FF";
 
    // used in the app
    static AapBackground: string = "#F6F8F9";
    static AapIndigo: string = "#00247F";
    static AapBrightIndigo: string = "#304FFE";
    static AapSaturatedIndigo: string = "#779BD1";
    static AapBlack: string = "#1B1F27";

    // currently unused colors
    // accents
    static AapWarmYellowAccent: string = "#00A651";
    static AapGreenAccent: string = "#1CD8BF";
    static AapBlueAccent: string = "#467AF3";
    static AapBlueVioletAccent: string = "#4400FD";
    static AapRedAccent: string = "#F82A4B";

    // S1, T1, T2 colors
    static AapYellowS1: string = "#804D00";
    static AapYellowT1: string = "FFD397";
    static AapYellowT2: string = "#FFF7E8";
    static AapGreenS1: string = "#008471";
    static AapGreenT1: string = "#97FFFF";
    static AapGreenT2: string = "#E6FFFF";
    static AapBlueS1: string = "#274485";
    static AapBlueT1: string = "#7DA6FF";
    static AapBlueT2: string = "#EAF3FF";
    static AapBlueVioletS1: string = "#3205B5";
    static AapBlueVioletT1: string = "#B499FE";
    static AapBlueVioletT2: string = "#E9E0FF";
    static AapRedS1: string = "#AB001C";
    static AapRedT1: string = "#F897A7";
    static AapRedT2: string = "#FFD9Df";







}